<template lang="pug">
  v-card(color="green lighten-2" dark hover @click="openList")
    v-card-text(style="height: 128px;")
      v-layout(align-center justify-center column fill-height)
        v-progress-circular(v-if="isLoading" size="70" width="7" color="white" indeterminate)
        animated-number.display-1.font-weight-light(v-if="!isLoading" :value="activeStore" :formatValue="formatToNumber" :duration="1000")
        div.text-xs-center.body-1 {{ $t('labels.activeStores') }}
</template>

<script>
import dashbaordService from '../../service.js'
import AnimatedNumber from "animated-number-vue";

export default {
  data() {
    return {
      activeStore: 0,
      isLoading: true
    }
  },
  components: {
    AnimatedNumber
  },
  mounted() {
    this.getStoreCount()
  },
  methods: {
    openList() {
      this.$router.push({name: 'location-dashboard', params: {option: 'active'}});
    },
    formatToNumber(value) {
      return `${value.toFixed(0)}`;
    },
    getStoreCount() {
      dashbaordService.getCustomerCount()
      .then(result => {
        this.activeStore = result.data.activeCustomerCount
        this.isLoading = false
        this.$emit('getCount', this.activeStore)
      })
    },
  }
}
</script>

<style scoped>
</style>